// extracted by mini-css-extract-plugin
module.exports = {"description":"_2q2nIP0","heading":"_20LbpNa"};